import cn from 'classnames'
import React, { ComponentProps } from 'react'

type MissingRequiredFieldsIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function MissingRequiredFieldsIcon(
  props: MissingRequiredFieldsIconProps,
) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('MissingRequiredFieldsIcon', className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect width="20" height="20" rx="10" fill="black" />
      <path
        d="M11 5.13477V7.20004C11 7.48006 11 7.62007 11.0545 7.72703C11.1024 7.82111 11.1789 7.8976 11.273 7.94554C11.38 8.00004 11.52 8.00004 11.8 8.00004H13.8653M12 10.5H8M12 12.5H8M9 8.5H8M11 5H8.4C7.55992 5 7.13988 5 6.81901 5.16349C6.53677 5.3073 6.3073 5.53677 6.16349 5.81901C6 6.13988 6 6.55992 6 7.4V12.6C6 13.4401 6 13.8601 6.16349 14.181C6.3073 14.4632 6.53677 14.6927 6.81901 14.8365C7.13988 15 7.55992 15 8.4 15H11.6C12.4401 15 12.8601 15 13.181 14.8365C13.4632 14.6927 13.6927 14.4632 13.8365 14.181C14 13.8601 14 13.4401 14 12.6V8L11 5Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
